export default {
    'add-new-role': 'Add New Role',
    'permissions': 'Permissions',
    'please-select-a-role': 'Please select a role',
    'job-title': 'Job title',
    'manager': 'Manager',
    'read': 'Read',
    'action': 'Action',
    'noThing': 'Nothing'
}